/**
 * Marketing Configuration
 *
 * Centralized configuration for marketing landing page
 * Update these values to reflect your business information
 */

export const MARKETING_CONFIG = {
  // Company Info
  companyName: 'Farm Aleros',
  tagline: 'ERP avícola construido en una granja real.',

  // Contact Information
  whatsapp: {
    // Phone number in international format WITHOUT + or spaces
    // Example: 504XXXXXXXX for Honduras
    phoneNumber: '504XXXXXXXX', // TODO: Replace with actual WhatsApp Business number

    // Default messages by source
    messages: {
      hero: 'Hola, quiero agendar una demo gratuita',
      pricing: 'Hola, tengo preguntas sobre los precios',
      enterprise: 'Hola, quiero información sobre el plan Enterprise',
      faq: 'Hola, tengo algunas dudas sobre el sistema',
      floating: 'Hola, vengo desde la web y quiero más información',
    },
  },

  email: 'info@farmaleros.com', // TODO: Replace with actual email

  // Social Media
  social: {
    tiktok: 'https://tiktok.com/@farmaleros',
    instagram: 'https://instagram.com/farmaleros',
    facebook: 'https://facebook.com/farmaleros',
    youtube: 'https://youtube.com/@farmaleros',
  },

  // Google Forms
  surveyFormURL: 'https://forms.gle/XXXXXXXX', // TODO: Replace with actual Google Form URL

  // SEO — Open Graph image is rendered dynamically by app/opengraph-image.tsx
  // (no static asset; Next auto-injects it into metadata for the landing page).
  seo: {
    title: 'Farm Aleros | Tu alero para llevar la granja',
    description: 'Un mini ERP construido en una granja real. Producción diaria, inventario auditado, multi-currency, 30+ KPIs con drill-down y un asistente de IA conectado a tus datos. 7 días gratis, sin tarjeta.',
    keywords: [
      'ERP avícola',
      'software granjas postura',
      'gestión avícola',
      'control producción huevos',
      'KPI avicultura',
      'multi-tenant avicultura',
      'Honduras',
    ],
  },

  // Analytics IDs
  analytics: {
    googleAnalyticsId: 'G-XXXXXXXXXX', // TODO: Replace with GA4 measurement ID
    metaPixelId: 'XXXXXXXXXXXXXXXX', // TODO: Replace with Meta Pixel ID
  },

  // Promotion
  promotion: {
    enabled: true,
    text: 'Pago anual: 2 meses gratis.',
    spotsLeft: 47, // TODO: Update manually as clients sign up
  },

  // Video Demo
  videoDemo: {
    url: '', // TODO: Add video URL (MP4) - Host on Cloudflare/Vimeo/YouTube
    thumbnail: '/marketing/video-thumbnail.jpg', // TODO: Add thumbnail image
  },
} as const;
